<template>
  <v-btn
    v-if="this.dados == 'OUTROS DOCUMENTOS'"
    rounded
    small
    color="secondary"
    @click="
      $router.push({ name: 'editar-documento', params: { id: atestado.codigo } })
    "
  >
    <v-icon size="17" class="mr-2">mdi-pencil</v-icon> Editar Documento</v-btn
  >

  <v-btn
    v-else
    rounded
    small
    color="secondary"
    @click="
      $router.push({ name: 'editar-atestado', params: { id: atestado.codigo } })
    "
  >
    <v-icon size="17" class="mr-2">mdi-pencil</v-icon>
    Editar atestado</v-btn
  >
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState("atestado", ["dados"]),
  props: {
    atestado: Object,
  },
};
</script>

<style>
</style>